import React from 'react'
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import {Provider, useDispatch} from 'react-redux'
// Axios
// import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query';

// Apps
import {App} from './app/App'
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import 'mdb-react-ui-kit/dist/css/mdb.min.css'

/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/css/style.rtl.css'
import './_metronic/assets/css/tailwind.css'
import './_metronic/assets/sass/style.react.scss'
import {Store} from './store/store'
import {UserInfoData} from './app/modules/api/auth'
import {USER_VERIFIED} from './actions'
import {AuthHandle} from './app/routing/AuthHandle'



const PUBLIC_URL = '/'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */


Chart.register(...registerables)
const queryClient = new QueryClient();

ReactDOM.render(
  <MetronicI18nProvider>
    <Provider store={Store}>
    <QueryClientProvider client={queryClient}>
        <App basename={PUBLIC_URL} />
        </QueryClientProvider>
    </Provider>
  </MetronicI18nProvider>,
  document.getElementById('root')
)
